/* MARCIASINI · beteendet ovanpå Dawn 16 (plan 2026-10-12-butikstema).
   Rummet räknas ut exakt som på marciasini.com: SHA-256 av e-postadressen → rum 3–22, aldrig 20. */
const MM_RUM = [3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,21,22];
const MM_FELRAD = 'The desk could not take your name just now. Try again, or write to bonjour@marciasini.com.';

async function mmRum(epost) {
  const b = new Uint8Array(await crypto.subtle.digest('SHA-256',
    new TextEncoder().encode(epost.trim().toLowerCase())));
  const n = ((b[0] << 24) | (b[1] << 16) | (b[2] << 8) | b[3]) >>> 0;
  return MM_RUM[n % MM_RUM.length];
}

function mmLasRum() {
  const m = document.cookie.match(/(?:^|; )mm_room=(\d+)/);
  return m ? m[1] : null;
}

function mmSattRum(r) {
  const dom = location.hostname.endsWith('marciasini.com') ? '; domain=.marciasini.com' : '';
  document.cookie = 'mm_room=' + r + dom + '; path=/; max-age=31536000; samesite=lax; secure';
}

const MM_TIDSGRANS = 12000;   // ms: svarar inte marciasini.com visas felraden eller reservmejlet

async function mmPost(vag, data) {
  const bas = document.documentElement.dataset.mmApi || 'https://marciasini.com';
  const avbryt = new AbortController();
  const klocka = setTimeout(() => avbryt.abort(), MM_TIDSGRANS);
  try {
    const svar = await fetch(bas + vag, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data), signal: avbryt.signal,
    });
    if (!svar.ok) throw new Error('HTTP ' + svar.status);
    return await svar.json();
  } finally {
    clearTimeout(klocka);
  }
}

/* Le Registre: incheckning. Rummet och kakan sätts först när marciasini.com har tagit emot namnet. */
function mmRegistre(form) {
  const ram = form.closest('[data-mm-registre-ram]') || form.parentElement;
  const ok = ram.querySelector('[data-mm-ok]');
  const fel = ram.querySelector('[data-mm-fel]');
  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    const falt = form.querySelector('input[type=email]');
    const epost = falt.value.trim();
    if (!epost) return;
    const knapp = form.querySelector('button');
    knapp.disabled = true;
    if (fel) fel.hidden = true;
    let rum = null;
    try { rum = await mmRum(epost); } catch (_) { rum = null; }
    try {
      await mmPost('/api/subscribe', { email: epost, source: form.dataset.source || 'boutique', room: rum ? String(rum) : '' });
    } catch (_) {
      if (fel) { fel.textContent = MM_FELRAD; fel.hidden = false; }
      knapp.disabled = false;
      return;
    }
    if (rum) mmSattRum(rum);
    form.hidden = true;
    if (ok) { ok.textContent = (form.dataset.okText || 'Welcome. Chambre N° [room] is yours.').replace('[room]', rum || ''); ok.hidden = false; }
    document.dispatchEvent(new CustomEvent('mm:incheckad', { detail: { rum } }));
  });
}

/* Hjältefilmen spelar bara när den syns, och står still för den som vill slippa rörelse. */
function mmHjaltefilm(film) {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) { film.pause(); film.removeAttribute('autoplay'); return; }
  new IntersectionObserver((rader) => rader.forEach((r) => {
    if (r.isIntersecting) film.play().catch(() => {}); else film.pause();
  }), { threshold: 0.2 }).observe(film);
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('form[data-mm-registre]').forEach(mmRegistre);
  document.querySelectorAll('.mm-hero video').forEach(mmHjaltefilm);
}

/* Den fasta köpknappen i mobil speglar Dawns köpknapp (slutsåld, vald storlek). */
function mmKopFast(knapp) {
  const original = document.getElementById(knapp.dataset.mmKopFast);
  if (!original) return;
  const spegla = () => {
    knapp.disabled = original.disabled;
    const text = original.querySelector('span');
    if (text) knapp.textContent = text.textContent.trim();
  };
  new MutationObserver(spegla).observe(original, { attributes: true, childList: true, subtree: true, characterData: true });
  spegla();
}
if (typeof document !== 'undefined') document.querySelectorAll('[data-mm-kop-fast]').forEach(mmKopFast);

/* Rumsnumret i La Note: fylls i ur kakan, även när Dawn ritar om lådan efter ett köp. */
function mmVisaRum(rot) {
  const rum = mmLasRum();
  if (!rum) return;
  (rot || document).querySelectorAll('[data-mm-chambre]').forEach((el) => {
    el.textContent = 'Chambre N° ' + rum + ' · Hôtel Marciasini';
  });
}

/* Le Courrier-rutan i hörnet. */
function mmCourrierCoin() {
  const coin = document.getElementById('mm-courrier-coin');
  const lada = document.querySelector('cart-drawer');
  if (!coin || !lada) return;
  const sedd = () => { try { return localStorage.getItem('mm_courrier_vu') === '1'; } catch (_) { return false; } };
  const markera = () => { try { localStorage.setItem('mm_courrier_vu', '1'); } catch (_) {} };
  const mobil = () => matchMedia('(max-width: 760px)').matches;
  const delai = Number(coin.dataset.delai) || 4500;
  let timer = null;
  let vantar = false;
  const visa = () => {
    if (sedd() || mmLasRum()) return;
    coin.hidden = false;
    requestAnimationFrame(() => coin.classList.add('on'));
    // mm_courrier_vu sparas först när besökaren stänger rutan, inte när den visas (Poyan 20/10: lagringen ska vara besökarens val)
  };
  const dolj = () => { coin.classList.remove('on'); setTimeout(() => { coin.hidden = true; }, 350); };
  new MutationObserver(() => {
    const oppen = lada.classList.contains('active');
    if (oppen && !timer && !sedd() && !mmLasRum()) {
      timer = setTimeout(() => {
        if (mobil() && lada.classList.contains('active')) vantar = true; else visa();
      }, delai);
    }
    if (!oppen && vantar) { vantar = false; setTimeout(visa, 300); }
  }).observe(lada, { attributes: true, attributeFilter: ['class'] });
  coin.querySelector('[data-mm-coin-x]').addEventListener('click', () => { markera(); dolj(); });
  document.addEventListener('mm:incheckad', () => { if (!coin.hidden) setTimeout(dolj, 4000); });
}

if (typeof document !== 'undefined') {
  mmVisaRum();
  document.addEventListener('mm:incheckad', () => mmVisaRum());
  new MutationObserver((andringar) => {
    for (const a of andringar) for (const n of a.addedNodes) if (n.nodeType === 1 && (n.matches('[data-mm-chambre]') || n.querySelector('[data-mm-chambre]'))) { mmVisaRum(); return; }
  }).observe(document.body, { childList: true, subtree: true });
  mmCourrierCoin();
}

/* Intresseanmälan på intressesidan. En ren anmälan (källan interet) checkar inte in; med Le Courrier-rutan
   (källan interet+ouverture) sätts rummet som vid en incheckning. */
const MM_INTERET_KOPPLADE = new WeakSet();
function mmInteret(form) {
  if (MM_INTERET_KOPPLADE.has(form)) return;
  MM_INTERET_KOPPLADE.add(form);
  const ram = form.closest('[data-mm-registre-ram]') || form.parentElement;
  const ok = ram.querySelector('[data-mm-ok]');
  const fel = ram.querySelector('[data-mm-fel]');
  // Utan JavaScript förblir den nya anmälningsknappen inaktiv.
  if (ram.matches('[data-mm-slut]')) form.querySelector('button[type=submit]').disabled = false;
  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    const epost = form.elements.email.value.trim();
    if (!epost) return;
    const courrier = form.elements.courrier.checked;
    const knapp = form.querySelector('button[type=submit]');
    knapp.disabled = true;
    if (fel) fel.hidden = true;
    let rum = mmLasRum();
    if (courrier && !rum) { try { rum = String(await mmRum(epost)); } catch (_) { rum = null; } }
    const delar = [form.dataset.produkt, form.dataset.namn];
    if (form.dataset.storlek) delar.push(form.dataset.storlek);
    const rad = delar.join(' · ');
    try {
      await mmPost('/api/subscribe', { email: epost, source: courrier ? 'interet+ouverture' : 'interet', room: rum || '', items: [rad] });
    } catch (_) {
      if (fel) { fel.textContent = MM_FELRAD; fel.hidden = false; }
      knapp.disabled = false;
      return;
    }
    if (courrier && rum) mmSattRum(rum);
    form.hidden = true;
    if (ok) { ok.textContent = form.dataset.okText || 'Noted. One e-mail when ' + form.dataset.namn + ' arrives.'; ok.hidden = false; }
    if (courrier) document.dispatchEvent(new CustomEvent('mm:incheckad', { detail: { rum } }));
  });
}
if (typeof document !== 'undefined') {
  document.querySelectorAll('form[data-mm-interet]').forEach(mmInteret);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, html } }) => {
      const id = 'mm-slut-' + sectionId;
      const block = document.getElementById(id);
      const nytt = html.getElementById(id);
      if (!block || !nytt) return;
      const ersattning = nytt.cloneNode(true);
      block.replaceWith(ersattning);
      ersattning.querySelectorAll('form[data-mm-interet]').forEach(mmInteret);
    });
  }
}

/* Ångra köp (2 kap. 10 a § DAL): steg 1 samlar uppgifterna, bara knappen i steg 2 skickar.
   Mottagningsbeviset med tidpunkt skickas av marciasini.com/api/angra; svarar den inte visas ett ifyllt mejl. */
function mmAngra(form) {
  const ram = form.closest('[data-mm-angra-ram]');
  const steg1 = form.querySelector('[data-mm-angra-steg="1"]');
  const steg2 = form.querySelector('[data-mm-angra-steg="2"]');
  const fel = form.querySelector('[data-mm-angra-fel]');
  const kvitto = ram.querySelector('[data-mm-angra-kvitto]');
  const reserv = ram.querySelector('[data-mm-angra-reserv]');
  const uppgifter = () => {
    const e = form.elements;
    const vissa = e.varor.value === 'some';
    return { name: e.namn.value.trim(), order: e.order.value.trim(), email: e.email.value.trim(),
             items: vissa ? e.vilka.value.trim() : 'All items in the order', hp: e.hp.value };
  };
  const rad = (dt, dd) => { const a = document.createElement('dt'); a.textContent = dt; const b = document.createElement('dd'); b.textContent = dd; return [a, b]; };
  form.querySelector('[data-mm-angra-vidare]').addEventListener('click', () => {
    const u = uppgifter();
    const ordernr = /^\s*(?:order\s*)?#?\s*\d{4,6}\s*$/i.test(u.order);   // samma regel som /api/angra
    if (!u.name || !ordernr || !u.email || !form.elements.email.checkValidity() || !u.items) {
      fel.textContent = 'Name, the order number as in your confirmation (#1001), e-mail and the items, please.';
      fel.hidden = false;
      return;
    }
    fel.hidden = true;
    const lista = form.querySelector('[data-mm-angra-sammanfattning]');
    lista.replaceChildren(...rad('Name', u.name), ...rad('Order', u.order),
      ...rad('Receipt to', u.email), ...rad('Items', u.items));
    steg1.hidden = true; steg2.hidden = false;
  });
  form.querySelector('[data-mm-angra-tillbaka]').addEventListener('click', () => { steg2.hidden = true; steg1.hidden = false; });
  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    if (steg2.hidden) return;                       // bara steg 2 skickar
    const u = uppgifter();
    const knapp = steg2.querySelector('button[type=submit]');
    knapp.disabled = true;
    reserv.hidden = true;                           // ett nytt försök: reservmejlet visas bara om det också misslyckas
    try {
      const svar = await mmPost('/api/angra', u);
      if (!svar || svar.ok !== true || !svar.mottaget) throw new Error('inget mottagningsbevis');   // aldrig ett kvitto utan serverns tidpunkt
      const t = new Date(svar.mottaget);
      const datumEn = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Stockholm', day: 'numeric', month: 'long', year: 'numeric' }).format(t);
      const tid = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Stockholm', hour: '2-digit', minute: '2-digit' }).format(t).replace(':', '.');
      const p = document.createElement('p');
      p.textContent = 'Received. A receipt is on its way to ' + u.email + ', with the time we received it: ' + datumEn + ' at ' + tid + ', Swedish time.';
      kvitto.replaceChildren(p);
      form.hidden = true; kvitto.hidden = false;
    } catch (_) {
      const amne = 'Withdrawal · Order ' + u.order;
      const kropp = 'Name: ' + u.name + '\nOrder: ' + u.order + '\nItems: ' + u.items + '\nReceipt to: ' + u.email +
        '\n\nI withdraw from this purchase.';
      reserv.querySelector('a').href = 'mailto:bonjour@marciasini.com?subject=' + encodeURIComponent(amne) + '&body=' + encodeURIComponent(kropp);
      reserv.hidden = false;
      knapp.disabled = false;
    }
  });
}
if (typeof document !== 'undefined') document.querySelectorAll('form[data-mm-angra]').forEach(mmAngra);
